import { FC } from "react";
import { PathItem } from "../../../types/PathItem";
import { DialogComponent } from "@syncfusion/ej2-react-popups";

interface IDeleteImageModal {
  open: boolean;
  onDeleteImage: (document: PathItem) => void;
  onClose: () => void;
  document: PathItem;
}

export const DeleteImageModal: FC<IDeleteImageModal> = ({
  open,
  onDeleteImage,
  onClose,
  document,
}) => {
  const dialogHeader = "CSM Shopfloor";

  const buttons = [
    {
      buttonModel: {
        content: "Yes",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        onDeleteImage(document);
      },
    },
    {
      buttonModel: {
        content: "No",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 200 };

  return (
    <DialogComponent
      width="400px"
      close={onClose}
      header={dialogHeader}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      Are you sure that you want to delete {document.fileName} image?
    </DialogComponent>
  );
};
